export const en_en = {
    // SCREENS
    // General
    loading: 'Loading...',
    // SignIn
    signin_title: 'Sign in',
    signin_redirect_title: 'Verify your login & password',
    psw_placeholder_redirect: 'Confirm password',
    psw_placeholder: 'Enter password',
    email_placeholder: 'Email address',
    language: 'Language',
    forgot_password: 'Forgot password?',
    signup_hint: "Don't have an account? Sign up",
    btn_signin: 'Sign In',
    // Intro
    // N-Ary sort
    my_profile: 'My preferences',
    btn_submit: 'Submit',
    btn_finish: 'Finish',
    hint_undo:
        'Are you certain you want to return to the previous statement you compared? \n\n (Please note that multiple comparisons may be lost)',
    // Global screen
    tip_quit: 'Are you sure you want to quit?',
    // State screen // Tell us, what is your ideal work environment?
    intro_title: 'Happiness is the key to success',
    intro_body: `If you love what you do and the team you work with, you will be successful in your professional life.`,
    howto1_title: `You will see 2 statements

    Click on the one you prefer

    This will only take 12 minutes.`,
    howto1_body: `You should take this in a quiet environment.`,
    award1_title: 'You have finished the first round, well done!',
    award1_body: `At the top of the following list you'll find what you consider to be the most important things in your ideal working environment. If you wish, you can rearrange the order of the statements by dragging and dropping them.`,
    award2_title: 'You are more than halfway done !',
    award2_body: `Dive into the excitement of discovering your ideal work environment! Your most crucial statements are right at the top of this list. Feel the thrill as you rearrange them to your heart's content by simply dragging and dropping! Your dream workspace is just a move away!`,
    award3_title: 'Congratulations for the third part',
    award3_body: `You're almost there! The finish line is within sight! Take a deep breath, give it your all in these final moments, and celebrate the incredible achievement that awaits you. You've got this! Finish strong, and let the success story unfold!`,
    howto2_title: 'And now the final questions - 2 minutes',
    howto2_body: `You will be asked a few more questions. You still need to order some statements, from the most important (top) to the least important (bottom).`,
    title_rank: 'In my **IDEAL** work environment,',
    subtitle_rank_2: 'what matters most is :',
    subtitle_rank_n: 'Where would you place the following statement?',
    hint_reorder: 'Reorder as needed, from most to least important',
    hint_overview: 'Click below to see the summary',
    hint_profile: 'My Current Preferences',
    hint_place_below: 'Place the statement below',
    title_rank_bucket: 'Very last comparisons',
    subtitle_rank_best: 'This time, which one is the MOST important to you?',
    subtitle_rank_least: 'Which one is the LEAST important to you?',
    subtitle_rank_reorder: 'Reorder from MOST to LEAST important',
    title_thanks: 'Well done!',
    hint_thanks: 'Thank you! Your preferences have been successfully submitted',
    title_error: 'We cannot send your data',
    hint_error: 'Please retry later ...',
    hint_error_validation: 'A validation error occurred, please retry later', // FIXME
    hint_error_dup: `You already submitted a previous report.`,
    hint_confirm_round: 'Are you sure you want to confirm this ranking?',
    retry_btn: 'Retry',
    btn_to_overview: 'OVERVIEW',
    btn_to_bucket_x: 'BUCKET',
    btn_to_params: 'PARAMS',
    btn_open: 'OPEN',
    btn_start: 'START',
    btn_confirm: 'CONFIRM',
    // btn_next: 'NEXT',
    btn_next: '>',
    btn_next_str: 'NEXT',
    btn_next_round: 'NEXT ROUND',
    // btn_prev: 'PREV',
    btn_prev: '<',
    btn_cancel: 'CANCEL',
    // btn_back: 'BACK',
    btn_back: '<',
    btn_download: 'Download your report',
    btn_quit: 'QUIT',
    // Comparisons
    pick_best: 'Which one is the most important to you?',
    pick_worst: 'Which one is the least important to you?',
    vs: 'OR',
    // UI elements
    round: 'Round',
    stm: 'Statement',
    bucket: 'Bucket',
    axis_y: 'Number of Stms',
    tip_saved: 'Saved',
    top_scale_hint: 'The **MOST** important',
    bottom_scale_hint: 'The **LEAST** important',
    pick_tip: 'Picked!',
    how_to_binary_title: 'Instructions',
    // values
    samen: 'Collaboration',
    conf: 'Conformity',
    erken: 'Recognition',
    zorg: 'Care',
    gelijk: 'Equality & diversity',
    zelfsturing: 'Autonomy',
    macht: 'Power',
    voorspelbaar: 'Predictability',
    prestatie: 'Performance',
    zelfontplooi: 'Self-development',
    duurzaam: 'Sustainability',
    integriteit: 'Integrity',
    innovatie: 'Innovation',
    daadkracht: 'Strength',
    //
    no_slug_error:
        'Please make sure you followed the right link, if you did contact administrator/support',
    unknown_error: 'An unknown error occured, please retry later',
    invalid_credentials: 'Invalid email / password combination',
    // 360
    // TLTM scale
    lvl0: 'Please select',
    lvl1: 'Way too little',
    lvl2: 'Too little',
    lvl3: 'Rather too little',
    lvl4: 'Right Amount',
    lvl5: 'A little too much',
    lvl6: 'Too much',
    lvl7: 'Way too much',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'Right Amount',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // NET PROMOT SCORE
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'Please select',
    lvlSC10x00e: '🤔',
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'Never',
    lvlSC10x0: 'None',
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'MISSING',
    lvlSC10x1: 'Extremely bad',
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'MISSING',
    lvlSC10x2: 'Very bad',
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'MISSING',
    lvlSC10x3: 'Insufficient',
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'MISSING',
    lvlSC10x4: 'Bad',
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'MISSING',
    lvlSC10x5: 'Mediocre',
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'MISSING',
    lvlSC10x6: 'Average',
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'MISSING',
    lvlSC10x7: 'Good',
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'MISSING',
    lvlSC10x8: 'Very good',
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'MISSING',
    lvlSC10x9: 'Excellent',
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'Certainly',
    lvlSC10x10: 'Impeccable',
    howto_360_title: `As an organization, we place a high value on values, and we believe it is essential to know what truly makes you happy in your work environment.`,
    howto_360_body: `This questionnaire is and will remain anonymous for your hierarchy, which will only receive aggregated results.`,
    picker_360_title_workenv: 'In my current work environment …',
    picker_360_title_leadership: 'My direct manager …',
    nps_title: 'To what extent would you recommend working here ?',
    comment_title: 'Add a comment',
    comment_placeholder:
        'We thank you for any constructive feedback on this statement',
    comment_save: 'Save and close',
    comment_remaining: 'character(s) left',
    howto_workenv_title:
        'Now share your impressions of your current working environment',
    howto_workenv_body:
        "How do you live it? Think of procedures, governance, systems, etc. Don't hesitate to leave a comment",
    howto_nps_title: 'Would you recommend your employer as a place to work?',
    howto_nps_body:
        'On a scale of 0 to 10, how likely are you to recommend your employer as a good place to work to your friends or family',
    // legacy_v2:
    btn_next_step: 'Next',
    to_assign: 'Unassigned',
    least_important: 'Least important',
    moderately_important: 'Moderately important',
    most_important: 'Most important',
    ranker_title: 'What is important in your ideal job?',
    too_insufficient_warning: 'This bucket contains too few statements',
    too_much_warning: 'This bucket contains too many statements',
    too_much_warning1: 'You have assigned too many statements to the bucket(s):',
    too_much_warning2: 'Click on the bucket and assign the statement(s) to another bucket until the distribution is correct',
    empty_bin: 'This bucket is empty',
    further_ranking: 'Please classify those {{v1}} statements, from - to + important',
    further_ranking1: 'Please classify those {{v1}} statements',
    further_ranking2: 'Please classify those {{v1}} statements',
    hint_modal_title: 'Imagine your ideal work environment',
    hint_modal_body1: 'Rank 42 statements about your ideal environment from least to most important',
    hint_modal_body2_left: 'left',
    hint_modal_body2_left_txt: 'the 11 statements you find the least important',
    hint_modal_body2_right: 'right',
    hint_modal_body2_right_txt: 'the 11 statements you find the most important',
    hint_modal_body2_middle: 'middle',
    hint_modal_body2_middle_txt: 'the 20 statements you find moderately important',
    hint_modal_body3: 'Drag and drop each statement into the bucket that suits you best',
    hint_modal_cta: 'Start',
    hint_top: 'Scroll up',
    hint_down: 'Scroll down',
    // Modal strings
    sort_middle_bucket_title: 'Would you like to sort the middle bucket?',
    sort_middle_bucket_body: 'This will sort the middle bucket by value.',
    reflect_current_view_title: 'Does this reflect the environment of your ideal job?',
    reflect_current_view_sort_body: 'If not, you will be offered to sort your final ranking',
    yes: 'Yes',
    no: 'No',
    final_ranking: 'Final Ranking',
    final_distribution_invalid_title: 'The final distribution is invalid',
    final_distribution_invalid_body: 'There is {{v1}} bucket(s) with too many statements and {{v2}} bucket(s) with too few statements',
    no_available_bins_warning: 'No available bins for random assignment - all bins are at maximum capacity',
    example: 'Example :',
} as const
